import type { LayoutListElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './LayoutListElement'
import type { LayoutListDemoType } from './layoutListTypes'

const DEMO_VALUE: LayoutListElementValue = {
  items: [{ label: 'label1', value: 'id1' }],
}

const LayoutListDemo: LayoutListDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.layoutList.type}-demo`,
        type: CONFIG_ELEMENTS.layoutList.type,
        value: DEMO_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default LayoutListDemo
